import { useState, useMemo } from 'react'
import React from 'react'
import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import SorterOrderOverview from 'orders/presentation/components/atoms/SorterOrderOverview/SorterOrderOverview'
import ClassificationRuleRow from 'orders/presentation/components/atoms/ClassificationRuleRow/ClassificationRuleRow'
import TemplateDetailModal from 'orders/presentation/components/molecules/TemplateDetailModal/TemplateDetailModal'
import AppInput from 'components/atoms/AppInput/AppInput'
import { ClassificationOrderAdapter, ClassificationRuleView } from 'orders/infrastructure/adapters/ClassificationOrderAdapter'

interface Props {
    progress: OrderProgressEntity | null
    onSearch?: (containerCode: string) => void
}

export default function ClassificationOrderDetail({ progress, onSearch }: Props) {
    const [search, setSearch] = useState('')
    const [showModal, setShowModal] = useState(false)

    const ruleViews: ClassificationRuleView[] = useMemo(() => {
        if (!progress) return []
        return ClassificationOrderAdapter.buildRuleViews(progress)
    }, [progress])

    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearch?.(search.trim())
        }
    }

    return (
        <div className="flex flex-col gap-6 mt-6">
            {progress && (
                <SorterOrderOverview progress={progress} onViewTemplate={() => setShowModal(true)} />
            )}

            {showModal && progress?.templateId && (
                <TemplateDetailModal
                    templateId={progress.templateId}
                    templateName={progress.templateName ?? ''}
                    isClassification={true}
                    onClose={() => setShowModal(false)}
                />
            )}

            <div className="flex flex-col">
                <div className="flex rounded-t-xl">
                    <button className="px-8 py-5 text-lg font-medium text-[#1E293B] bg-white rounded-t-lg focus:outline-none">
                        Avance
                    </button>
                </div>

                <div className="bg-white rounded-b-xl rounded-tr-xl px-6 py-6 flex flex-col gap-4">
                    <div className="flex items-center gap-2 w-72">
                        <AppInput
                            placeholder="Buscar contenedor..."
                            name="search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={handleSearch}
                        />
                        {/* Botón filtro deshabilitado temporalmente */}
                        {/* <button
                            type="button"
                            className="flex items-center justify-center w-10 h-10 rounded-lg border border-[#CBD5E1] bg-white hover:bg-gray-50"
                            aria-label="Filtrar"
                        >
                            <DynamicIcon name="filter" className="w-5 h-5 text-gray-500" />
                        </button> */}
                    </div>

                    <div className="flex flex-col gap-4">
                        {ruleViews.map((ruleView, index) => (
                            <ClassificationRuleRow
                                key={`${ruleView.name}-${ruleView.sequence ?? index}`}
                                ruleView={ruleView}
                            />
                        ))}
                        {ruleViews.length === 0 && (
                            <p className="text-sm text-[#64748B] text-center py-8">
                                No se encontraron reglas
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
